import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { IApiResponseData } from 'model/interfaces';
import {
  RemoveReportAccessParams,
  ShareReportAccessPayloadData,
  UsersDetails,
  UsersDetailsURLParams,
} from 'model/types';

export const useReportAccessService = () => {
  const fetchUsersDetails = async (params: UsersDetailsURLParams) => {
    return (
      await kf1AuthenticatedHttpClient<UsersDetails>({
        baseURL: ENV_VARS.API_URL.replace('payequity/', 'iam/v2/'),
        url: 'users/details',
        method: 'GET',
        params,
      })
    ).data;
  };

  const shareReportAccess = async (payload: ShareReportAccessPayloadData) => {
    return (
      await kf1AuthenticatedHttpClient<IApiResponseData<any>>({
        baseURL: ENV_VARS.API_URL,
        url: 'report/share',
        method: 'POST',
        data: payload,
      })
    ).data;
  };

  const removeReportAccess = async (params: RemoveReportAccessParams) => {
    return (
      await kf1AuthenticatedHttpClient<IApiResponseData<any>>({
        baseURL: ENV_VARS.API_URL,
        url: 'report/share',
        method: 'DELETE',
        params,
      })
    ).data;
  };

  return {
    fetchUsersDetails,
    shareReportAccess,
    removeReportAccess,
  };
};
